module.exports = __webpack_public_path__ + "static/media/Export_Icon.9d5b87b6.svg";